import React from "react";

const RecetaLista = ({ recetas, onAbrirReceta }) => {
  return (
    <div className="recetas-lista">
        <div className="recetas-table-header">
    <div>Paciente</div>
    <div>Fecha</div>
    <div>Diagnóstico</div>
    <div>Acciones</div>
  </div>
      {recetas.length > 0 ? (
        recetas.map((receta) => (
          <div
            key={receta.id}
            className="receta-item"
            onClick={() => onAbrirReceta(receta)}
          >
          <p>{receta.nombrePaciente || "Paciente no registrado"}</p>
          <p>{receta.fecha || "No registrada"}</p>
          <p>{receta.diagnostico || "No registrado"}</p>

            <button
              className="ver-receta-button"
              onClick={(e) => {
                e.stopPropagation();
                onAbrirReceta(receta);
              }}
            >
              Ver receta
            </button>
          </div>
        ))
      ) : (
        <p>No se encontraron recetas.</p>
      )}
    </div>
  );
};

export default RecetaLista;